export function getStrategy(testResult) {
  const strategies = {
    ia: 'Confident Individualism',
    ea: 'People Mastery',
    it: 'Constant Improvement',
    et: 'Social Engagement',
  };
  const introverted = testResult.introverted || 0;
  const extroverted = testResult.extroverted || 0;
  const assertive = testResult.assertive || 0;
  const turbulent = testResult.turbulent || 0;

  const strategy =
    (introverted > extroverted ? 'i' : 'e') +
    (assertive > turbulent ? 'a' : 't');
  return strategies[strategy];
}

export const codeLetterText = {
  e: 'extroverted',
  i: 'introverted',
  s: 'observant',
  n: 'intuitive',
  f: 'feeling',
  t: 'thinking',
  j: 'judging',
  p: 'prospecting',
  as: 'assertive',
  tu: 'turbulent',
};

export function getVariant(mainTestResult) {
  const assertive = mainTestResult[codeLetterText.as] || 0;
  const turbulent = mainTestResult[codeLetterText.tu] || 0;
  return assertive >= turbulent ? codeLetterText.as : codeLetterText.tu;
}

export default {
  questions: {
    group1: [
      {
        id: 1,
        title: 'You often make new friends',
      },
      {
        id: 2,
        title:
          'You have wide-ranging interests and love to learn all about them',
      },
      {
        id: 3,
        title: 'You feel upset when you see that someone else is sad',
      },
      {
        id: 4,
        title: 'You always have a contingency plan',
      },
      {
        id: 5,
        title: "You're confident about the future",
      },
      {
        id: 6,
        title: "You're cool, calm, and collected under pressure",
      },
    ],
    group2: [
      {
        id: 7,
        title: 'At parties, you stick with people you know ',
      },
      {
        id: 8,
        title: "It's best to finish one piece of work before starting another",
      },
      {
        id: 9,
        title: 'You see meaning in the little things around you',
      },
      {
        id: 10,
        title: 'You organize your time with diaries and timetables',
      },
      {
        id: 11,
        title: 'A minor mistake can lead you to question your abilities',
      },
      {
        id: 12,
        title: 'You can chat with anyone',
      },
    ],
    group3: [
      {
        id: 13,
        title:
          'You love to think about the underlying meaning of books, movies, art, and music',
      },
      {
        id: 14,
        title: 'You use logic more than your emotions when you make decisions',
      },
      {
        id: 15,
        title: "You're spontaneous and don't really have a daily routine",
      },
      {
        id: 16,
        title: "You're not bothered by what strangers think of you",
      },
      {
        id: 17,
        title: 'You enjoy team sports or other group activities',
      },
      {
        id: 18,
        title:
          'You enjoy books, video games, and/or movies where the ending is ambiguous',
      },
    ],
    group4: [
      {
        id: 19,
        title:
          'You work behind the scenes to help other people accomplish their goals',
      },
      {
        id: 20,
        title:
          "You experience “option paralysis,” where you can't move forward because you're unable to make a decision",
      },
      {
        id: 21,
        title: 'You often worry that things will go wrong',
      },
      {
        id: 22,
        title: "Being a leader doesn't really interest you",
      },
      {
        id: 23,
        title:
          'Sometimes you really wish other people would make decisions rationally, rather than relying on their feelings',
      },
      {
        id: 24,
        title: 'You would describe yourself as artistic or creative',
      },
    ],
    group5: [
      {
        id: 25,
        title: 'You finish the housework before you sit down to relax',
      },
      {
        id: 26,
        title: 'You really enjoy a good debate',
      },
      {
        id: 27,
        title:
          'You like to blend in and prefer not to draw attention to yourself',
      },
      {
        id: 28,
        title: 'You can be moody',
      },
      {
        id: 29,
        title:
          "You become impatient with people who aren't working efficiently",
      },
      {
        id: 30,
        title: 'You tend to leave things until the last minute',
      },
    ],
    group6: [
      {
        id: 31,
        title: "Sometimes you wonder if there's an afterlife",
      },
      {
        id: 32,
        title: 'You would rather be surrounded by other people than be alone',
      },
      {
        id: 33,
        title:
          'Discussions about theory bore you, your interests are more practical',
      },
      {
        id: 34,
        title:
          "You find it easy to see things from other people's perspectives, even when their lives have been completely different from yours",
      },
      {
        id: 35,
        title: 'You prefer to leave your options open for as long as you can',
      },
      {
        id: 36,
        title:
          "Usually, you don't look back and wonder if you made the wrong decision",
      },
    ],
    group7: [
      {
        id: 37,
        title:
          'After a long and stressful week, you love to let your hair down and socialize',
      },
      {
        id: 38,
        title: 'Art galleries and museums can be fascinating',
      },
      {
        id: 39,
        title: "Other people's emotions often confuse you",
      },
      {
        id: 40,
        title: 'You have a to-do list for each day',
      },
      {
        id: 41,
        title: "You're confident most of the time",
      },
      {
        id: 42,
        title: 'You hate talking on the phone',
      },
    ],
    group8: [
      {
        id: 43,
        title:
          'You do your best to understand where other people are coming from',
      },
      {
        id: 44,
        title:
          "You're the one who brings your friends together for social occasions and outings",
      },
      {
        id: 45,
        title:
          'When your plans are disrupted, you get things back on track quickly',
      },
      {
        id: 46,
        title: 'You have many regrets',
      },
      {
        id: 47,
        title:
          "You're focused on the here and now, and you rarely think about the meaning of life",
      },
      {
        id: 48,
        title: 'You often feel out of control when it comes to your emotions',
      },
    ],
    group9: [
      {
        id: 49,
        title: "You try to spare other people's feelings",
      },
      {
        id: 50,
        title:
          'You have spurts of energy where you get a lot done, but you find it hard to apply consistent effort',
      },
      {
        id: 51,
        title:
          'When other people praise you, you become nervous about disappointing them',
      },
      {
        id: 52,
        title: 'You enjoy working alone',
      },
      {
        id: 53,
        title: "You don't have much time for abstract, philosophical questions",
      },
      {
        id: 54,
        title: 'You prefer crowds and festivals to quiet, tranquil places',
      },
    ],
    group10: [
      {
        id: 55,
        title: "You can read another person's emotions instantly",
      },
      {
        id: 56,
        title: 'You often feel stressed and overwhelmed',
      },
      {
        id: 57,
        title: 'You like to take things step-by-step',
      },
      {
        id: 58,
        title: "You're drawn to unusual and controversial topics",
      },
      {
        id: 59,
        title:
          'You would let someone else take something you wanted, if you thought they needed it more',
      },
      {
        id: 60,
        title: "You're energized by deadlines",
      },
      {
        id: 'gender',
        title: 'Select your gender',
        type: 'radiogroup',
        optional: true,
        initialValue: 'male',
        skipProgress: true,
        descriptionText: 'This will determine your avatar in the results screen',
        options: [
          {
            value: 'male',
            label: 'Male',
          },
          {
            value: 'female',
            label: 'Female',
          },
          { value: 'other', label: 'Other' },
        ],
      },
    ],
  },
};

export const answersGroup = {
  mind: {
    title: 'Mind',
    description: 'This trait determines how we interact with our environment',
    letters: ['i', 'e'],
    color: 'blue',
  },
  energy: {
    title: 'Energy',
    description: 'This trait shows where we direct our mental energy',
    letters: ['s', 'n'],
    color: 'orange',
  },
  nature: {
    title: 'Nature',
    description:
      'This trait determines how we make decisions and cope with emotions',
    letters: ['f', 't'],
    color: 'mint',
  },
  tactics: {
    title: 'Tactics',
    description:
      'This trait reflects our approach to work, planning and decision-making',
    letters: ['j', 'p'],
    color: 'red',
  },
  identity: {
    title: 'Identity',
    description:
      'This trait underpins all others, showing how confident we are in our abilities and decisions',
    letters: ['as', 'tu'],
    color: 'brown',
  },
};
